<template>
    <td :class="{ 'cell-edit':!this.disabled, 'text-white': this.bgColor}" :style="{background:bgColor}">
      <vx-tooltip :delay="tooltipDelay" :text="tooltipText" :tooltipPosition="tooltipPosition">
        <template  v-if="!isEditing">
            {{value.label}}
        <feather-icon style="float:right;" icon="ChevronDownIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" v-if="!isEditing" @click="startEditing"/>
        </template>
        <template v-else>
            <select class="vue-select" v-model="selected.value" @change="update" @keyup.esc="stopEditing" >
                <option v-for="(option,i) in options" :key="i" :value="option.value">{{option.label}}</option>
            </select>
        </template>
        </vx-tooltip>
    </td>
</template>
<script>
import axios from 'axios'
import internalPortal from '@/http/requests/internalPortal'
export default {
  props:{
    id:{
      required:true
    },
    column:{
      type:String,
      required:true
    },
    keys:{
      type:Object,
      required:true,
      default:{
        value:'',
        label:''
      }
    },
    value:{
      type:Object,
      required:true,
      default:{
        value:'',
        label:''
      }
    },
    items:{
      type:Array,
      required:true
    },
    tooltipDelay:{
          type:String,
          default:'1.5s'
    },
    tooltipPosition:{
          type:String,
          default:'top'
    },
    tooltipText:{
        type:String,
        default:null
    },
    bgColor:{
        type:String,
        required:false,
    },
    disabled:{
      type:Boolean
    }
  },
  data:() => ({
    isEditing:false,
    selected:{},
    options:[],
    data:{
      id:null,
      column:'',
      value:''
    }
  }),
  methods:{
    getOptions () {    
      if (this.items.length > 0) {
            this.options = this.items.map((item) => ({value:item[this.keys.value],label:item[this.keys.label]}))
            this.options.unshift({label:'Select Option', value:null})
            this.selected = this.options[0]
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Alert',
              text: 'No items'
            })
            this.stopEditing()
          }
    },
    startEditing () {
       if(this.disabled) return
      if (!this.isEditing) {
        this.getOptions()
        this.selected = this.options[0]
        this.data.id = this.id
        this.data.column = this.column
        this.data.value = this.selected.value
        this.isEditing = true
      }
    },
    stopEditing () {
      this.isEditing = false
    },
    update () {
      this.stopEditing()
      this.data.value = this.selected.value
      if (this.value.value != this.data.value && this.data.value !== null) {
        this.$emit('update', this.data)
      }
    }
  }
}
</script>

<style>
    .vue-select{
        padding: 12px;
        border: 1px solid #cfd9db;
        background-color: #ffffff;
        border-radius: 0.25em;
        box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.08);
        display: block;
        width: 100%;
        appearance: none;
        position: relative;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
        cursor: pointer;
    }

    .vue-select:focus {
        outline: none;
        border-color: #2c3e50;
        box-shadow: 0 0 5px rgba(44, 151, 222, 0.2);
    }

    .vue-select::after {
        content: "";
        position: absolute;
        z-index: 1;
        right: 16px;
        top: 50%;
        margin-top: -8px;
        display: block;
        width: 16px;
        height: 16px;
        background: url("data:image/svg+xml;charset=utf-8,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22utf-8%22%3F%3E%0D%0A%3C%21DOCTYPE%20svg%20PUBLIC%20%22-%2F%2FW3C%2F%2FDTD%20SVG%201.1%2F%2FEN%22%20%22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22%3E%0D%0A%3Csvg%20version%3D%221.1%22%20id%3D%22Layer_1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20x%3D%220px%22%20y%3D%220px%22%0D%0A%09%20width%3D%2216px%22%20height%3D%2216px%22%20viewBox%3D%220%200%2016%2016%22%20enable-background%3D%22new%200%200%2016%2016%22%20xml%3Aspace%3D%22preserve%22%3E%0D%0A%3Cg%3E%0D%0A%09%3Cpolygon%20fill%3D%22%232c3e50%22%20points%3D%220.9%2C5.5%203.1%2C3.4%208%2C8.3%2012.9%2C3.4%2015.1%2C5.5%208%2C12.6%20%09%22%2F%3E%0D%0A%3C%2Fg%3E%0D%0A%3C%2Fsvg%3E") no-repeat center center;
        pointer-events: none;
    }
    .vue-select::-ms-expand {
  display: none;
}

</style>